import React from "react";
import {Link} from 'react-router-dom'
import Banner from "./Banner";
const Supply = () => {


   const products = [
    { id: 1, name: "Piperine extract ", img: "/images/piperine.webp" },
    { id: 2, name: "Kutki root extract ", img: "/images/Kutki_root_extract.webp" },
    { id: 3, name: "Green coffee", img: "images/greencofee.webp" },
{ id: 4, name: "Saffron extract", img: "images/safron_extract.webp" },  ];


  return (
    <div className="px-4 md:px-10 py-8 md:py-12 bg-gray-100">


      <div className="px-4 md:px-10 py-8 md:py-12">
        <h2 className="text-xl md:text-2xl font-bold mb-6 text-center md:text-left">
          Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded shadow p-3">
              
              <img
                src={product.img}
                alt={product.name}
                className="rounded w-full h-40 md:h-48 object-cover"
              />

              <h3 className="mt-2 font-semibold text-sm md:text-base">
                {product.name}
              </h3>

              <Link
                to="/products"
                className="block mt-2 text-center bg-green-600 text-white py-1 rounded text-sm hover:bg-green-700"
              >
                View More
              </Link>

            </div>
          ))}
        </div>
      </div>

  

      <div className="max-w-5xl mx-auto">
        <h2 className="text-xl md:text-2xl font-bold mb-4 text-center md:text-left mt-5">
          Supply
        </h2>

        <p className="text-sm md:text-base text-gray-700 leading-relaxed text-center md:text-left">
          We provide bulk supply of herbal raw materials and extracts across India,
          catering to diverse industrial requirements with flexible sourcing and
          reliable dispatch options.
        </p>

        <p className="text-sm md:text-base text-gray-700 leading-relaxed mt-3 text-center md:text-left">
          Our network enables consistent availability of quality materials,
          ensuring smooth procurement for manufacturers, wholesalers, and
          nutraceutical businesses.
        </p>

        <p className="text-sm md:text-base text-gray-700 leading-relaxed mt-3 text-center md:text-left">
          We accommodate custom requirements based on quantity, specifications,
          and delivery timelines, maintaining a strong focus on efficiency,
          transparency, and timely support.
        </p>

        {/* Highlights */}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm md:text-base">
          <div className="bg-white shadow rounded p-3">
            ✔ Pan-India Delivery
          </div>
          <div className="bg-white shadow rounded p-3">
            ✔ Flexible Bulk Orders
          </div>
          <div className="bg-white shadow rounded p-3">
            ✔ Reliable Logistics Support
          </div>
        </div>

      </div>
    </div>
  );
};

export default Supply;